import styled from 'styled-components';
import { COLORS } from '../../../constants/radar';

export const Container = styled.div`
  padding: 24px;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: ${COLORS.BACKGROUND_PRIMARY};
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  background: white;
  padding: 16px 24px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`;

export const HeaderLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

export const BackButton = styled.button`
  background: none;
  border: none;
  color: ${COLORS.SECONDARY};
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.2s ease;

  &:hover {
    background-color: ${COLORS.BACKGROUND};
    color: ${COLORS.PRIMARY};
    transform: translateX(-2px);
  }

  svg {
    font-size: 16px;
  }
`;

export const Title = styled.h1`
  color: ${COLORS.PRIMARY};
  font-size: 24px;
  margin: 0;
  font-weight: 600;
  position: relative;
  padding-left: 16px;

  &:before {
    content: '';
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    height: 24px;
    width: 4px;
    background-color: ${COLORS.PRIMARY};
    border-radius: 2px;
  }
`;

export const VersionBadge = styled.span`
  background-color: #EEF2FF;
  color: #4F46E5;
  font-size: 0.65rem;
  padding: 2px 6px;
  border-radius: 4px;
`;

export const Content = styled.div`
  flex: 1;
  background: white;
  border-radius: 8px;
  padding: 24px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  overflow-y: auto;
`;
